export default "__VITE_ASSET__BLzgmTXk__"